import * as React from "react";
import { useDispatch, useIntl } from "@grandvisionhq/state";
import { useConfiguratorContext } from "../../../../../../../../Context/Context/ConfiguratorContext.js";
import { usePrivateSteppingContext } from "../../../../../../../../Context/Context/PrivateSteppingContext.js";
import { toggleFooter } from "../../../../../../../../state/state/actions.js";
import { ExpanderToggle } from "./ExpanderToggle.js";
const ExpanderToggleContainer = (props) => {
  const dispatch = useDispatch();
  const { getLabel } = useIntl();
  const { isFooterOpen, configuratorId: id, isOnLastStep } = useConfiguratorContext();
  const { footerExpanderContent, hideExpanderOnLastStep } = usePrivateSteppingContext();
  const toggleFooter$1 = React.useCallback(() => {
    dispatch(toggleFooter({ id }));
  }, [dispatch, id]);
  if (!footerExpanderContent || hideExpanderOnLastStep && isOnLastStep) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ExpanderToggle,
    {
      ...props,
      label: getLabel("products.glasses.configurator.footer.toggle"),
      isExpanded: isFooterOpen,
      onToggleClick: toggleFooter$1
    }
  );
};
export {
  ExpanderToggleContainer
};
//# sourceMappingURL=ExpanderToggleContainer.js.map
